var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BestRecruitLayout',[_c('Surrounding',{attrs:{"about-company":_vm.aboutCompany.environment}}),_c('Welfare',{attrs:{"about-company":_vm.aboutCompany.welfare}}),_c('Multiple',{attrs:{"carousel-list":_vm.aboutCompany['diversity']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }